require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./digital-realities-ar-colony-square.json") })
        }
      }, "path---digital-realities-ar-colony-square");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---digital-realities-ar-colony-square!./.cache/json/digital-realities-ar-colony-square.json
// module id = 387
// module chunks = 231608221292675